module.exports = __webpack_public_path__ + "img/people-simple.286759ad.svg";